<script lang="ts">
    import AtAGlanceRow from './AtAGlanceRow.svelte';

    /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
    export let race;

    /**
     * @type {Map<string, import('../types.d').Crosswalk>}
     */
    export let crosswalk;

    function getAnchorTag(raceId) {
      if (raceId == 'CA-A6142-2022-06-07') {
        return 'attorney-general';
      } else if (raceId == 'CA-G6119-2022-06-07') {
        return 'governor';
      }
    }

    $: idName = getAnchorTag($race.id);
  
  </script>
    <p class="aag-race">{$race.name}</p>
    <p class="aag-leading">Leading candidates</p>

  <table class="contest__candidates aag">
    <tbody>
        {#each $race.candidates as c, idx (c.ap_id)}
          {#if idx < 2}
          <tr
          class="candidate contest__candidate-row contest__candidate-row-{c.party}"
          class:contest__candidate-row-winner={c.is_winner}>
          <AtAGlanceRow 
            candidateGivenName = {c.given_name}
            candidateFamilyName = {c.family_name}
            isIncumbent = {c.is_incumbent}
            isWinner = {c.is_winner}
            candidateParty = {c.party}
            candidateVotes = {c.votes}
            totalVotes = {$race.total_votes}
            lookup={crosswalk.get(c.ap_id)}
            raceID = {$race.id}
          />
          </tr>
          {/if}
        {/each}
    </tbody>
    <tfoot>
      <tr>
        <td class="contest__precincts" colspan=2>{$race.eevp}% of expected vote in</td>
        <td class="link-to-section text-right" colspan="2"><a href="#{idName}" aria-label="Link to go to race">Go to race &raquo;</a></td>
      </tr>
    </tfoot>
  </table>
  